import React, { Component } from 'react'
import T from 'i18n-react'
import CSSModules from 'react-css-modules'
import { branch, renderNothing } from 'recompose'
import { IconButton } from 'react-toolbox'

import { hideSpecItem, getCurStatus } from 'helpers/specHelpers'
import SpecItem from 'components/custom/SpecItem/index'
import ListItemSpec from 'containers/Project/ListItemSpec/index'
import ItemComponent from './ItemComponent'
import {
  SPEC_ORDER,
} from 'containers/Project/Specifications/constants'
import {
  FILTER_ALL,
  FILTER_RISK,
  FILTER_MODIFIED,
} from 'containers/Project/Specifications/constants'

import styles from './styles.scss'

class ListSpec extends Component {
  getPropLabel(moduleName, prop) {
    return T.translate(`project.spec.${moduleName}.item.${prop}`)
  }

  generateItem(initValues, modifiedValues, curInit, curModified) {
    const {
      moduleName,
      moduleData,
      isModifiedPage,
      curFilter,
      config,
    } = this.props
    const getPropOrder = moduleName => SPEC_ORDER[moduleName]

    const customModuleNames = config && config.customModuleNames ? config.customModuleNames : {}

    return getPropOrder(moduleName).map((property, index) => {
      const initValue = curInit ? curInit[property] : ''
      const modifiedValue = curModified ? curModified[property] : ''
      const risk = property === 'partNumber' && curModified ? curModified.risk === 'Risk' : false
      const curStatus = getCurStatus(risk, initValue, modifiedValue)
      const moduleListName = customModuleNames[property] ? `${moduleName}.item.${property}` : `${moduleName}.item`
      // if (hideSpecItem(isModifiedPage, modifiedValue, initValue, risk, curFilter))
      //   return        
      return (
        (curInit && Array.isArray(curInit[property])) ||
        (curModified && Array.isArray(curModified[property])) ?
          <ListItemSpec
            key={index}
            moduleName={moduleListName}
            moduleData={{
              initValues: curInit ? curInit[property] : [],
              modifiedValues: curModified ? curModified[property] : [],
            }}
            isModifiedPage={isModifiedPage}
            risks={curModified ? curModified.risks : false}
            curFilter={curFilter}
          /> :
          <SpecItem
            key={index}
            label={this.getPropLabel(moduleName, property)}
            initValue={initValue}
            modifiedValue={modifiedValue}
            isModifiedPage={isModifiedPage}
            risk={risk}
            curFilter={curFilter}
            curStatus={curStatus}
          />
      )
    })
    // filter null values
    .filter(val => val)
  }

  generateItemList() {
    const {
      moduleName,
      moduleData,
      isModifiedPage,
      curFilter,
      firstRowHeader
    } = this.props
    const itemList = []

    if (!moduleData) return itemList

    const {
      initValues,
      modifiedValues,
    } = moduleData
    const moduleOrder = SPEC_ORDER[moduleName]
    const listLen = Math.max(initValues ? initValues.length : 0, modifiedValues ? modifiedValues.length : 0)
    let key = 1

    for (let i = 0; i < listLen; i++) {
      const curInit = initValues ? initValues[i] : null
      const curModified = modifiedValues ? modifiedValues[i] : null
      const items = this.generateItem(initValues, modifiedValues, curInit, curModified)

      if (items.length > 0) {
        let header = ''
        if (!isModifiedPage && firstRowHeader) {
          // Use first item as header
          const firstRow = moduleOrder[0]
          items.shift()
          header = `${this.getPropLabel(moduleName, firstRow)}: ${curModified[firstRow]}`
        } else {
          header = `${this.getPropLabel(moduleName, 'label')}${i+1}`
        }

        const item = <ItemComponent key={key} header={header} items={items} />

        itemList.push(item)
        key++
      }
    }

    return itemList
  }

  render() {
    const { ModuleHeader } = this.props
    const itemList = this.generateItemList()
    const Header = branch(
      () => itemList.length <= 0,
      renderNothing
    )(ModuleHeader)

    return (
      <div>
        <Header />
        <div styleName='specItemList'>
          { itemList ? itemList : null }
        </div>
      </div>
    )
  }
}

export default CSSModules(ListSpec, styles)
